import { Box, Backdrop, CircularProgress } from "@mui/material";

export const showLoader = (activeLoaderFlags: boolean[]) =>
  activeLoaderFlags.every(Boolean) && (
    <Box textAlign={"center"} margin={1}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={activeLoaderFlags.every(Boolean)}
      >
        <CircularProgress size={100} color="inherit" />
      </Backdrop>
    </Box>
  );
